"use client"

import { motion } from "framer-motion"
import { Mountain } from "lucide-react"

export default function RoughEmeraldsHeader() {
  return (
    <motion.header
      className="bg-gradient-to-r from-emerald-900 via-teal-800 to-emerald-800 text-white py-10 px-6"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center gap-3">
          <motion.div
            whileHover={{ rotate: 360, scale: 1.1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            className="bg-amber-800/30 p-3 rounded-full"
          >
            <Mountain className="w-10 h-10 text-emerald-300" />
          </motion.div>
          <motion.h1
            className="text-4xl md:text-5xl font-serif tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-emerald-200 to-emerald-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Rough Emerald Collection
          </motion.h1>
        </div>

        <motion.p
          className="mt-4 text-emerald-300  max-w-3xl text-lg font-light text-center mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Discover our premium selection of natural, uncut emeralds sourced directly from the world's finest mines. Each
          stone preserves its natural beauty and geological history.
        </motion.p>
      </div>
    </motion.header>
  )
}
